import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import App from '@app/index';
import ClerkProviderWithRouter from 'src/providers/ClerkProviderWithRouter';
import { captureUiError, initErrorTracking } from 'src/lib/errorTracking';
import { getTraceId } from 'src/lib/trace';

if (process.env.NODE_ENV !== "production") {
  const config = {
    rules: [
      {
        id: 'color-contrast',
        enabled: false
      }
    ]
  };
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const axe = require("react-axe");
  axe(React, ReactDOM, 1000, config);
}

const traceId = getTraceId();
initErrorTracking();
window.addEventListener('error', (event) => {
  captureUiError(event.error ?? new Error(event.message), {
    trace_id: traceId,
    source: 'window.error',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});
window.addEventListener('unhandledrejection', (event) => {
  captureUiError(event.reason, {
    trace_id: traceId,
    source: 'window.unhandledrejection',
  });
});

const root = ReactDOM.createRoot(document.getElementById("root") as Element);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProviderWithRouter>
        <App />
      </ClerkProviderWithRouter>
    </BrowserRouter>
  </React.StrictMode>
)
